import styled from "styled-components";

export const CheckboxStyle = styled.label`

display: flex;
align-items: center;
justify-content: center;

text-transform: uppercase;
text-transform: uppercase;
font-size: 10px;
font-weight: 500;
letter-spacing: 0.1rem;
span{
    margin-left: 5px;
    display: inline-block;
    width: 15px;
    height: 15px;
    background: rgba(255,255,255,0.5);
    position: relative;
    box-shadow: 0 0 1px 1px inset #000;
    cursor: pointer;
    margin-right: ${props => props.label ? '5px' : ''};

}

strong{
    margin-left: 0.2rem;
    color: var(--fontColor);
    font-weight: 700;
}

input{
    position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

input:checked ~ span{
    background: rgb(255,255,255);
    box-shadow: 0 0 1px 1px inset #000;
}

input:checked ~ span:after{
    content: "";
    position: relative;
    display: block;
 top: 1px;
  width: 3px;
  height: 8px;
  margin: auto auto;
  border: solid rgb(0,0,0);
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

`